import { AuthScreen } from './AuthScreen';
import { useAuth, useSessionUser } from '../../lib/auth';

/**
 * `reason="not_member"` (default): signed in, but there is no `seo.members` row for this account.
 * `reason="refused"`: the database refused a read for this account (Postgres 42501).
 */
export default function NotAllowed({ reason = 'not_member' }: { reason?: 'not_member' | 'refused' }) {
  const { signOut } = useAuth();
  const user = useSessionUser();
  const who = <b>{user?.email || 'an unknown account'}</b>;
  return (
    <AuthScreen title="This account does not have access">
      {reason === 'refused' ? (
        <>
          <p>You are signed in as {who}, but the database refused to show this account's data.</p>
          <p className="mut">Your access may have changed. Sign out and in again; if it happens again, ask the owner to check your role in Settings.</p>
        </>
      ) : (
        <>
          <p>You are signed in as {who}, but that email is not on the SEO HQ team list.</p>
          <p className="mut">Ask the owner to add it in Settings, then sign in again. If the invite went to a different email, sign out and use that one.</p>
        </>
      )}
      <button type="button" className="btn primary" onClick={() => void signOut()}>
        Sign out
      </button>
    </AuthScreen>
  );
}
